// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__8s+pC","markdown":"Messages_markdown__a4Zhr","message":"Messages_message__O19dD"};